import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { createPortal } from 'react-dom';
import { Button } from '../../../../../../infra/dls/components/button/button';
import { useToggle } from '../../../../../../infra/small-tools/use-toggle';
import { CampaignAction } from '../../../../../../types/engage-campaign';
// eslint-disable-next-line max-len
import { RenameCampaignModalContainer as RenameCampaignModal } from '../../../../components/rename-campaign-modal/rename-campaign-modal.container';
import { usePortalNode } from '../../../components/header/use-portal-node';
import { useBreakpoints } from '../../../../../../infra/dls/hooks/use-get-breakpoints';
import { queryClient } from '../../../../../../../queryClient';
import { queryKeys } from '../../../../network/query-keys';
export var RenameCampaignButton = function (_a) {
    var campaign = _a.campaign;
    var isMobileOrSmaller = useBreakpoints().isMobileOrSmaller;
    var mobileNode = usePortalNode('mobile-next-step-portal');
    var desktopNode = usePortalNode('desktop-next-step-portal');
    var showRenameModal = useToggle(false);
    var handleSuccessUpdate = function () {
        queryClient.invalidateQueries({
            queryKey: queryKeys.campaignById(campaign.id),
        });
    };
    if (!campaign.allowedActions.includes(CampaignAction.RENAME)) {
        return null;
    }
    if (isMobileOrSmaller) {
        if (!mobileNode) {
            return null;
        }
        return createPortal(_jsxs(_Fragment, { children: [_jsx(Button, { variant: "secondary", fullWidth: true, onClick: showRenameModal.setOn, children: "Rename" }), showRenameModal.isOn && (_jsx(RenameCampaignModal, { campaign: campaign, onClose: showRenameModal.setOff, onSuccessUpdate: handleSuccessUpdate }))] }), mobileNode);
    }
    if (!desktopNode) {
        return null;
    }
    return createPortal(_jsxs(_Fragment, { children: [_jsx(Button, { variant: "secondary", onClick: showRenameModal.setOn, children: "Rename" }), showRenameModal.isOn && (_jsx(RenameCampaignModal, { campaign: campaign, onClose: showRenameModal.setOff, onSuccessUpdate: handleSuccessUpdate }))] }), desktopNode);
};
